import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sn-placeholder-item',
  template: `
      <div class="placeholder-item"
      [ngStyle]="style"
      [ngClass]="{ small: isSmall, medium: isMedium, large: isLarge, box: isBox, line: isLine, 'card-placeholder': isCard }">
    </div>
  `,
  styleUrls: ['./placeholder-item.component.scss']
})
export class PlaceholderItemComponent implements OnInit {

  @Input() size: ITEM_SIZE;
  @Input() type: ITEM_TYPE = ITEM_TYPE.LINE;
  @Input() align: 'right' | 'left' | 'center';
  @Input() style: any;

  @HostBinding('class.small') isSmall = false;
  @HostBinding('class.medium') isMedium = false;
  @HostBinding('class.large') isLarge = false;


  constructor() { }

  ngOnInit(): void {
    this.isSmall = this.size === ITEM_SIZE.SMALL ? true : false;
    this.isMedium = this.size === ITEM_SIZE.MEDIUM ? true : false;
    this.isLarge = this.size === ITEM_SIZE.LARGE ? true : false;
  }

  get isBox() {
    return this.type === ITEM_TYPE.BOX;
  }

  get isLine() {
    return this.type === ITEM_TYPE.LINE;
  }

  get isCard() {
    return this.type === ITEM_TYPE.CARD;
  }
}

export enum ITEM_SIZE {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  FULL = 'full'
}

export enum ITEM_TYPE {
  LINE = 'line',
  BOX = 'box',
  CARD = 'card'
}
